export default __webpack_public_path__ + "static/media/paint-roller.d693bf16.webp";